module.exports = __webpack_public_path__ + "static/media/totes.63180c01.svg";